import { rest } from 'msw'

export default [
  /**
   * MBR 演算設定
   */
  rest.get('/swc-api/nodes/:nodeId/mbr/calculation-settings', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    return res(
      ctx.status(200),
      ctx.json([
        {
          "id": 1,
          "node_id": 1,
          "calculation_no": 2,
          "module_name": "モジュール2",
          "calculation_type": "MBR",
          "organization_code": "2",
          "organization_name": "C 社",
          "calculation_setting": {
              "input": {
                  "suction_pressure_field": "mbr_P001_s2",
                  "wash_process_low_fields": ["W75C_21", "W75C_27"],
                  "wash_process_high_fields": [],
                  "suction_pump_process_fields": ["W754_03", "W754_04"],
                  "valve_open_process_fields": ["W754_31", "W756_01"],
                  "filtration_timer_field": null,
                  "suction_pressure_alarm_fields": ["W704_27"],
                  "treated_water_flow_field": null
              },
              "fixed_value": {
                  "suction_pressure_value": null,
                  "wash_process_low_value": null,
                  "wash_process_high_value": null,
                  "suction_pump_process_value": null,
                  "valve_open_process_value": null,
                  "filtration_timer_value": 168,
                  "suction_pressure_alarm_value": null,
                  "treated_water_flow_value": null
              },
              "calculation": {
                  "detail01_result_thresholod": 3,
                  "detail02_result_thresholod": 0.5,
                  "detail03_result_thresholod": 3,
                  "total_result_thresholod": 2
              },
              "notification": {
                  "notify_flag": "true"
              },
              "graph_settings": null
          }
      },
      {
        "id": 2,
          "node_id": 1,
          "calculation_no": 3,
          "module_name": "モジュール3",
          "calculation_type": "MBR",
          "organization_code": "2",
          "organization_name": "C 社",
          "calculation_setting": {
              "input": {
                  "suction_pressure_field": "mbr_P001_s3",
                  "wash_process_low_fields": ["W75E_05", "W75E_11"],
                  "wash_process_high_fields": [],
                  "suction_pump_process_fields": ["W756_17", "W756_18"],
                  "valve_open_process_fields": ["W758_13", "W758_15"],
                  "filtration_timer_field": null,
                  "suction_pressure_alarm_fields": ["W710_05"],
                  "treated_water_flow_field": null
              },
              "fixed_value": {
                  "suction_pressure_value": null,
                  "wash_process_low_value": null,
                  "wash_process_high_value": null,
                  "suction_pump_process_value": null,
                  "valve_open_process_value": null,
                  "filtration_timer_value": 168,
                  "suction_pressure_alarm_value": null,
                  "treated_water_flow_value": 100.0
              },
              "calculation": {
                  "detail01_result_thresholod": 3,
                  "detail02_result_thresholod": 0.5,
                  "detail03_result_thresholod": 3,
                  "total_result_thresholod": 2
              },
              "notification": {
                  "notify_flag": "true"
              },
              "graph_settings": {
                "units": [
                    {
                        "max": "2",
                        "min": "-50",
                        "name": "m3/h"
                    }
                ]
            }
          }
      },
      ]),
    )
  }),
  /**
   * MBR 演算設定新規登録
   */
   rest.post('/swc-api/nodes/:nodeId/mbr/calculation-settings', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    return res(
      ctx.status(200),
      ctx.json([])
    )
  }),
  /**
   * MBR 演算設定更新
   */
  rest.put('/swc-api/nodes/:nodeId/mbr/calculation-settings/:calculationSettingsId', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    return res(
      ctx.status(200),
      ctx.json([])
    )
  }),
  /**
   * MBR 演算設定削除
   */
  rest.delete('/swc-api/nodes/:nodeId/mbr/calculation-settings/:calculationSettingsId', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    return res(
      ctx.status(200),
      ctx.json([])
    )
  }),
]
